import React from 'react';
import Home from './pages/Home';
import Case from './pages/Case';

import {BrowserRouter, Routes, Route, HashRouter} from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import Footer from "./components/Footer";
import Header from "./components/Header";


const App = () => {
  return (
    <HashRouter>
      <Header/>
      <ScrollToTop/>
      <Routes>
        <Route path="/" element={<Home/>}/>
        <Route path="case/:name" element={<Case/>}/>
      </Routes>
      <Footer/>
    </HashRouter>
  );
};

export default App;
